/**
 * Mail Icon
 *
 * Simple envelope icon without checkmark.
 */

import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

interface MailIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
}

const MailIcon = forwardRef<HTMLDivElement, MailIconProps>(
  ({ className, size = 28, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={className}
        {...props}
      >
        <svg
          fill="none"
          height={size}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
          viewBox="0 0 24 24"
          width={size}
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
      </div>
    );
  }
);

MailIcon.displayName = "MailIcon";

export { MailIcon };
